<template>
  <div>
    <!-- Party Details -->
    <PartyDetailsCard
      class="mb-4"
      :item="peParty"
    />

    <div v-if="peSurveysValidationActive">
      <PartyDetailsCard
        v-for="item of partySurveyCardsByIdentifiers('party-details-card')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <!-- Identifiers -->
    <IdentifiersCard
      :id="id"
      :item="peParty"
      class="mb-4"
    />

    <div v-if="peSurveysValidationActive">
      <IdentifiersCard
        v-for="item of partySurveyCardsByIdentifiers('identifiers-card')"
        :id="id"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <!-- Addicional Identifiers -->
    <div>
      <AdditionalIdentifiersCard
        v-for="ident of peParty.identifiers"
        :key="ident.id"
        :item="ident"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <AdditionalIdentifiersCard
        v-for="item of partySurveyCardsByIdentifiers('additional-identifiers-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Identifier"
      :has-new-section="peAddictionalIdentifiersCardHasNewSection"
      @on-add="peAdditionalIdentifiersCardAddSection"
    />

    <!-- Demographics -->
    <DemographicsCard
      :id="id"
      :item="peParty"
      class="mb-4"
    />

    <div v-if="peSurveysValidationActive">
      <DemographicsCard
        v-for="item of partySurveyCardsByIdentifiers('demographics-card')"
        :id="id"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <PhysicalAddressCard
      class="mb-4"
      :item="peParty.physical_address"
    />

    <div v-if="peSurveysValidationActive">
      <PhysicalAddressCard
        v-for="item of partySurveyCardsByIdentifiers('physical-address-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <MailingAddressCard
      class="mb-4"
      :item="peParty.mailing_address"
    />

    <div v-if="peSurveysValidationActive">
      <MailingAddressCard
        v-for="item of partySurveyCardsByIdentifiers('mailing-address-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <RelativeSectionAdderLine
      title="Address"
      property="addresses"
      @on-add="onImportAddresses"
    />

    <!-- Email Cards -->
    <div>
      <EmailCard
        v-for="email of peParty.emails"
        :key="email.id"
        :item="email"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <EmailCard
        v-for="item of partySurveyCardsByIdentifiers('email-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Email"
      :has-new-section="peEmailCardHasNewSection"
      @on-add="peEmailCardAddSection"
    />

    <RelativeSectionAdderLine
      title="Email"
      property="emails"
      @on-add="peEmailMultipleCardCreate"
    />

    <!-- Phone Cards -->
    <div>
      <PhoneCard
        v-for="phone of peParty.phones"
        :key="phone.id"
        :item="phone"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <PhoneCard
        v-for="item of partySurveyCardsByIdentifiers('phone-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Phone"
      :has-new-section="pePhoneCardHasNewSection"
      @on-add="pePhoneCardAddSection"
    />

    <RelativeSectionAdderLine
      title="Phone"
      property="phones"
      @on-add="pePhoneMultipleCardCreate"
    />

    <!-- AKA Cards -->
    <div>
      <AKACard
        v-for="aka of peParty.akas"
        :key="aka.id"
        :item="aka"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <AKACard
        v-for="item of partySurveyCardsByIdentifiers('aka-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="AKA"
      :has-new-section="peAKACardHasNewSection"
      @on-add="peAKACardAddSection"
    />

    <!-- Passport Cards -->
    <div>
      <PassportCard
        v-for="passport of peParty.passports"
        :key="passport.id"
        :item="passport"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <PassportCard
        v-for="item of partySurveyCardsByIdentifiers('passport-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Passport"
      :has-new-section="pePassportCardHasNewSection"
      @on-add="pePassportCardAddSection"
    />

    <!-- ImmigrationStatus Cards -->
    <div>
      <ImmigrationStatusCard
        v-for="immigration_status of peParty.immigration_statuses"
        :key="immigration_status.id"
        :item="immigration_status"
        class="mb-4"
      />
    </div>

    <div v-if="peSurveysValidationActive">
      <ImmigrationStatusCard
        v-for="item of partySurveyCardsByIdentifiers('immigration-status-card-')"
        :key="item.identifier"
        :item="item.inputs"
        :survey-identifier="item.identifier"
        class="mb-4"
        survey-validation
      />
    </div>

    <SectionAdderLine
      section="Immigration Status"
      :has-new-section="peImmigrationStatusCardHasNewSection"
      @on-add="peImmigrationStatusCardAddSection"
    />

    <!-- Narratives Cards -->
    <div>
      <NarrativesCard
        v-for="narr of peParty.narratives"
        :key="narr.id"
        :item="narr"
        class="mb-4"
      />
    </div>

    <SectionAdderLine
      section="Narrative"
      :has-new-section="peNarrativesCardHasNewSection"
      @on-add="peNarrativesCardAddSection"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { alertHandler } from '@/alertHandler'

import { PARTY_NAMESPACE } from '@/store/party'

import AKACard from './SectionCards/PersonalDataCards/AKACard.vue'
import AdditionalIdentifiersCard from './SectionCards/PersonalDataCards/AdditionalIdentifiersCard.vue'
import DemographicsCard from './SectionCards/PersonalDataCards/DemographicsCard.vue'
import EmailCard from './SectionCards/PersonalDataCards/EmailCard.vue'
import IdentifiersCard from './SectionCards/PersonalDataCards/IdentifiersCard.vue'
import ImmigrationStatusCard from './SectionCards/PersonalDataCards/ImmigrationStatusCard.vue'
import MailingAddressCard from './SectionCards/PersonalDataCards/MailingAddressCard.vue'
import NarrativesCard from './SectionCards/PersonalDataCards/NarrativesCard.vue'
import PartyDetailsCard from './SectionCards/PersonalDataCards/PartyDetailsCard.vue'
import PassportCard from './SectionCards/PersonalDataCards/PassportCard.vue'
import PhoneCard from './SectionCards/PersonalDataCards/PhoneCard.vue'
import PhysicalAddressCard from './SectionCards/PersonalDataCards/PhysicalAddressCard.vue'
import RelativeSectionAdderLine from './SectionTools/RelativeSectionAdderLine.vue'
import SectionAdderLine from './SectionTools/SectionAdderLine.vue'

export default {
  name: 'PEPersonalDetails',

  components: {
    AKACard,
    AdditionalIdentifiersCard,
    DemographicsCard,
    EmailCard,
    IdentifiersCard,
    ImmigrationStatusCard,
    MailingAddressCard,
    NarrativesCard,
    PartyDetailsCard,
    PassportCard,
    PhoneCard,
    PhysicalAddressCard,
    RelativeSectionAdderLine,
    SectionAdderLine,
  },

  beforeRouteLeave (_, __, next) {
    if (this.peAnyUnlockedSections) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.peLockPartySections()
        next()
      } else next(false)
    } else {
      this.peLockPartySections()
      next()
    }
  },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  setup () {
    return { ...alertHandler() }
  },

  computed: {
    ...mapGetters(PARTY_NAMESPACE, [
      'peAKACardHasNewSection',
      'peAddictionalIdentifiersCardHasNewSection',
      'peAnyUnlockedSections',
      'peEmailCardHasNewSection',
      'peGenericSectionLoading',
      'peImmigrationStatusCardHasNewSection',
      'peNarrativesCardHasNewSection',
      'peParty',
      'pePassportCardHasNewSection',
      'pePhoneCardHasNewSection',
    ]),

    ...mapGetters(PARTY_NAMESPACE, [
      'partySurveyCardsByIdentifiers',
      'peSurveysValidationActive',
    ]),
  },

  created () {
    this.peGetPartySection({ id: this.id }).
      catch(() => this.displayAlert('error', `No Party found with the id: ${this.id}`))
  },

  methods: {
    onImportAddresses (addresses) {
      const mailingAddressId = this.peParty.mailing_address.id
      const physicalAddressId = this.peParty.physical_address.id

      for (const address of addresses) {
        if (address.address_type === 'mailing') {
          this.peMailingAddressCardUpdate({ id: mailingAddressId, section: address })
        } else {
          this.pePhysicalAddressCardUpdate({ id: physicalAddressId, section: address })
        }
      }
    },

    ...mapActions(PARTY_NAMESPACE, [
      'peAKACardAddSection',
      'peAdditionalIdentifiersCardAddSection',
      'peEmailCardAddSection',
      'peEmailMultipleCardCreate',
      'peGetPartySection',
      'peImmigrationStatusCardAddSection',
      'peLockPartySections',
      'peMailingAddressCardUpdate',
      'peNarrativesCardAddSection',
      'pePassportCardAddSection',
      'pePhoneCardAddSection',
      'pePhoneMultipleCardCreate',
      'pePhysicalAddressCardUpdate',
    ]),
  },
}
</script>
